import React, { useState } from 'react';
import '../../Commissioning/RasterProgressScreen/RasterProgressScreen.css';
import './HeatmapDiagRasterProgressScreen.css';

const HeatmapDiagRasterProgressBar = (props) => {
  const [fade] = useState(false);
  let opacity = fade ? '0' : '1';

  return (
    <div
      id="HeatmapDiagRasterProgressScreen_Inner_Container"
      className="HeatmapDiagRasterProgressScreen_Inner_Container"
      style={{ opacity: opacity }}
    >
      <div id="HeatmapDiagRasterProgressScreen_Text" className="HeatmapDiagRasterProgressScreen_Text">
        {props.title}
      </div>
      <div
        id="HeatmapDiagRasterProgressScreen_Progress_Container"
        className="HeatmapDiagRasterProgressScreen_Progress_Container"
      >
        <div
          id="HeatmapDiagRasterProgressScreen_Progress_Outer"
          className="HeatmapDiagRasterProgressScreen_Progress_Outer"
        >
          <div
            id="HeatmapDiagRasterProgressScreen_Progress_Inner"
            className="HeatmapDiagRasterProgressScreen_Progress_Inner"
            style={{ width: `${props.progress}%` }}
          />
          <div
            id="HeatmapDiagRasterProgressScreen_Progress_Border"
            className="HeatmapDiagRasterProgressScreen_Progress_Border"
          />
        </div>
      </div>
    </div>
  );
};

export default React.memo(HeatmapDiagRasterProgressBar);
